import React from 'react';
import {
  BooleanInput,
  FormWithRedirect,
  TextInput,
  useNotify,
  useRefresh,
  useUpdate,
  FormDataConsumer,
} from 'react-admin';
import DialogContent from '@material-ui/core/DialogContent';
import ModalView from './ModalView';
import CustomActions from './CustomActions';

const FleetEdit = ({ openEdit, setOpenEdit, customer }) => {
  const [update, { loading }] = useUpdate('customer');

  const notify = useNotify();
  const refresh = useRefresh();

  const handleSubmit = (values) => {
    const valuesToSubmit = values;
    // If is_fleet_user is not checked, delete value for fleet_account_name so customer doesn't appear in search results
    if (!valuesToSubmit.is_fleet_user) {
      valuesToSubmit.fleet_account_name = null;
    }
    update(
      {
        payload: {
          id: customer.id,
          data: valuesToSubmit,
          previousData: customer,
        },
      },
      {
        onSuccess: () => {
          setOpenEdit(false);
          notify('Fleet information updated successfully');
          refresh();
        },
        onFailure: ({ error }) => {
          notify(error.message, 'warning');
        },
      },
    );
  };

  return (
    <ModalView openEdit={openEdit} setOpenEdit={setOpenEdit}>
      <FormWithRedirect
        resource="customer"
        record={customer}
        save={handleSubmit}
        render={(formProps) => (
          <>
            <DialogContent>
              <BooleanInput label="Is fleet user?" source="is_fleet_user" />
              <FormDataConsumer>
                {({ formData }) => {
                  if (formData.is_fleet_user) {
                    return <TextInput source="fleet_account_name" />;
                  }
                  return null;
                }}
              </FormDataConsumer>
            </DialogContent>
            <CustomActions
              {...formProps}
              setOpenEdit={setOpenEdit}
              loading={loading}
            />
          </>
        )}
      />
    </ModalView>
  );
};

export default FleetEdit;
